import type { Icon } from '@change/ds-icons';
import { GroupsIcon, SendIcon, SpeakerFilledIcon } from '@change/ds-icons';

export type BulletPoint = {
	Icon: React.FC<Icon>;
	text: string;
	size: Icon['size'];
};

export const BULLET_POINTS: BulletPoint[] = [
	{
		Icon: SendIcon,
		text: 'Ask supporters to share with friends',
		size: 'medium',
	},
	{
		Icon: GroupsIcon,
		text: 'Ask supporters to contact decision maker',
		size: 'medium',
	},
	{
		Icon: SpeakerFilledIcon,
		text: 'Celebrate petition news and milestones',
		size: 'small',
	},
];
